import { Component, computed, inject, Input, signal } from '@angular/core';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';
import { TooltipDirective } from '../../../../common/directives/tooltip/tooltip.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'sbr-creator-review-item',
  standalone: true,
  imports: [TooltipDirective],
  templateUrl: './creator-review-item.component.html',
  styleUrl: './creator-review-item.component.css'
})
export class CreatorReviewItemComponent {

  @Input() creator!: {
    creatorId?: string;
    id?: string;
    name: string;
    instagramHandle?: string;
    tiktokHandle?: string;
  };

  @Input() briefId!: string;

  /** Services */
  private router = inject(Router);
  private socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  /** Display Values */
  approvedCount = signal<number>(0);
  issueFoundCount = signal<number>(0);
  totalCount = signal<number>(0);
  totalReviewedCount = signal<number>(0);


  questionsTested = signal<number>(0);
  issuesFound = signal<number>(0);
  contentWithIssues = signal<number>(0);
  /** Display Values - END */

  ngOnInit(): void {
    // console.log('CreatorReviewItem -> ', JSON.stringify(this.creator, null, 2), ' -> ', this.briefId);
    console.log('CreatorReviewItem -> ', this.creator);
    this.getScreeningGraphData();
  }

  getScreeningGraphData() {
    if (this.creator.id && this.briefId) {
      // console.log('Getting screening graph data for: ', this.creator.name + ' -> ' + this.creator.id + ' -> ' + this.briefId);
      this.socialScreeningService.getScreeningResults(this.creator.id, this.briefId).subscribe((results: {
        content: {
          id: string;
          reviewResults: {
            approvedCount: number;
            issueFoundCount: number;
            totalCount: number;
          }
        }[],
        summary: {
          briefId: string;
          creatorId: string;
          contentCount: number;
          reviewedCount: number;
          updatedAt: string;
        }
      }) => {
        console.log('Screening results: ', results);

        this.totalCount.set(results.summary.contentCount);
        this.totalReviewedCount.set(results.summary.reviewedCount);

        // Reset counters before aggregating
        this.questionsTested.set(0);
        this.issuesFound.set(0);
        this.contentWithIssues.set(0);

        for (const content of results.content) {
          this.questionsTested.set(this.questionsTested() + content.reviewResults.totalCount);
          this.issuesFound.set(this.issuesFound() + content.reviewResults.issueFoundCount);
          if (content.reviewResults.issueFoundCount > 0) {
            this.contentWithIssues.set(this.contentWithIssues() + 1);
          }
        }

        console.log('Issue Rate: ', this.contentWithIssues() / this.totalReviewedCount() * 100);
      });
    }
  }

  getSuccessPercentage() {
    if (this.totalReviewedCount() === 0) return 0;
    return Math.round(((this.totalReviewedCount() - this.issuesFound()) / this.totalReviewedCount()) * 100);
  }

  getPercentageClasses() {
    const percentage = this.getSuccessPercentage();

    if (percentage >= 90) {
      return {
        background: 'bg-green-50 dark:bg-green-400/10 dark:text-green-400 inset-ring inset-ring-green-600/20 dark:inset-ring-green-500/20',
        text: 'text-green-700 dark:text-green-400'
      };
    } else if (percentage >= 70) {
      return {
        background: 'bg-yellow-50 dark:bg-yellow-400/10 dark:text-yellow-400 inset-ring inset-ring-yellow-600/20 dark:inset-ring-yellow-500/20',
        text: 'text-yellow-700 dark:text-yellow-400'
      };
    } else if (percentage >= 50) {
      return {
        background: 'bg-orange-50 dark:bg-orange-400/10 dark:text-orange-400 inset-ring inset-ring-orange-600/20 dark:inset-ring-orange-500/20',
        text: 'text-orange-700 dark:text-orange-400'
      };
    }
    else {
      return {
        background: 'bg-red-50 dark:bg-red-400/10 dark:text-red-400 inset-ring inset-ring-red-600/20 dark:inset-ring-red-500/20',
        text: 'text-red-700 dark:text-red-400'
      };
    }
  }

  navigateToReport() {
    this.router.navigate(['/screening-brief-report', this.briefId, this.creator.id]);
  }
}
